import { useState } from "react";
import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useStripe } from "@stripe/react-stripe-js";

import { Loader } from "./loader";
import AlertDialog from "./AlertDialog";
import { getObjLength } from "../helpers/utils";
import { resolveCompletePaymentRequest } from "../for-service-provider/createUserApiPaths";
import CardList from "../userProfile/OrderDocuments/CradList";
import InlinePaymentCheckout from "../userProfile/add-property/InlinePaymentCheckout";
import TailwindPropertyPayment from "../userProfile/add-property/TailwindPropertyPayment";
import { subscriptionAction } from "../../redux/slices/subscription/subscriptionSlice";

const SecurePaymentPanel = ({
  displayLabel,
  cardData,
  paymentData,
  onSuccessFun = () => {},
  onFailedFun = () => {},
  userId,
  cardList = true,
  successMsg,
  successClose = true,
  onSuccessModalClose,
  last_steps = {},
  is_renew = false,
  // for promocoed
  addPromoCode = false,
  promoCodeValue = "",
  // Code already applied to the price; prefills the Tailwind promo field.
  defaultPromoCode = "",
  paySecure = () => {},
  // fro add properties
  from = "",
  uid = null,
  default_card_id = null,
  callListingAPI = () => {},
  setTotalAmountModal,
  isUserCreateProperty = false,
  callListAPI = false,
  clearOrderDoc = true,
  path = null,
  onClose = () => {},
  isOpenFromBottom = false,
  setValdiateModal = () => {},
  setValidation3DMsg = () => {},
  propertiesIds = undefined,
  selectedData = {},
  agent_id = undefined,
  selectedCategory = "complete_protection",
  isTailwindComponent = false,
  isAdmin = false,
  skipSuccessModal = false,
  userEmail = undefined,
  inlineCheckout = false,
  stripeErr = "",
  validateStripeErr = () => {},
  showInlineCardForm = true,
  onInlineCardPay,
  inlinePayLoading = false,
  inlinePayLabel,
  isServiceProvider = false,
  isAdminCreateUser = false,
  isUpgradeCategory = false,
  isEnhancedToCompleteProtection = false,
  finalAmount = null,
  onFinalAmountChange = () => {},
}) => {
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [validationMsg, setValidationMsg] = useState("");

  const stripe = useStripe();
  const dispatch = useDispatch();

  const { threedSecurePayment, threedSecurePaymentLoader } = useSelector(
    (state) => state?.subscription,
  );
  const { userProfileDetails } = useSelector((state) => state?.userProfile);
  const { servicerProfileDetails } = useSelector(
    (state) => state?.servicerProfile,
  );
  const { invToken } = useSelector((state) => state?.propertyRiskManagement);

  const clientSecret = async () => {
    const { paymentIntent, error } = await stripe.confirmCardPayment(
      paymentData?.data?.clientSecret,
      { payment_method: paymentData?.data?.card },
    );
    console.log("paymentIntent", paymentIntent);
    let isPaymnetDone = "";
    if (getObjLength(paymentIntent)) {
      isPaymnetDone = true;
    }
    if (getObjLength(error)) {
      isPaymnetDone = false;
      setValidationMsg(error?.message);
      setValidation3DMsg(error?.message);
    }

    let finaldata = {
      json_res_ids: paymentData?.data?.json_res_ids,
      isPaymnetDone: isPaymnetDone,
      user_id:
        userId ||
        userProfileDetails?.data?.user_id ||
        servicerProfileDetails?.data?.user_id,
      is_renew: is_renew,
    };

    if (agent_id) {
      finaldata = { ...finaldata, agent_id: agent_id, ...paymentData?.data };
    }

    if (getObjLength(last_steps)) {
      finaldata = { ...finaldata, ...last_steps };
    }

    if (
      paymentData?.data?.doc_payment_id !== null &&
      paymentData?.data?.doc_request_id !== null
    ) {
      finaldata = {
        ...finaldata,
        doc_payment_id: paymentData?.data?.doc_payment_id,
        doc_request_id: paymentData?.data?.doc_request_id,
      };
    }
    console.log("final data=>", finaldata);
    const { url: URL, token } = resolveCompletePaymentRequest({
      path,
      selectedCategory,
      isServiceProvider,
      isAdminCreateUser,
      userId: finaldata.user_id,
    });
    if (selectedCategory === "enhanced_monitoring") {
      finaldata.from_admin = isAdmin;
    }
    dispatch(
      subscriptionAction.get3dSecurePaymentData({
        url: URL,
        data: finaldata,
        ...(token ? { token: true } : {}),
      }),
    );
    setPaymentLoader(false);
    console.log("paymentIntent", paymentIntent);
    console.log("paymentIntent error", error);
  };

  const onSuccessModal = () => {
    onSuccessFun();
    if (clearOrderDoc) {
      dispatch(subscriptionAction.clear3dSecurePaymentData({}));
    }
  };

  const handleSuccessModalClose = () => {
    if (onSuccessModalClose) {
      onSuccessModalClose();
      return;
    }
    onSuccessModal();
  };

  const onFailedModal = () => {
    if (callListAPI) {
      callListingAPI();
    }
    onFailedFun();
    localStorage.setItem("paymentPopup", 0);
    dispatch(subscriptionAction.clear3dSecurePaymentData({}));
  };

  useEffect(() => {
    if (paymentData?.success) {
      if (paymentData?.data?.actionRequired) {
        setPaymentLoader(true);
        console.log("stripe==>", stripe);
        console.log("paymentIntent --", paymentData);
        clientSecret();
      }
    }
  }, [paymentData]);

  useEffect(() => {
    if (
      getObjLength(threedSecurePayment) &&
      skipSuccessModal &&
      threedSecurePayment?.success
    ) {
      onSuccessModal();
    }
  }, [threedSecurePayment, skipSuccessModal]);

  useEffect(() => {
    if (getObjLength(threedSecurePayment)) {
      // Only open the parent success path when 3DS completion succeeded.
      // Failures stay on this panel's Error dialog; do not flip valdiateModal
      // or the parent will treat the original paymentIntent success as done.
      if (threedSecurePayment?.success) {
        setValdiateModal(true);
      } else {
        setValdiateModal(false);
      }
    }
  }, [threedSecurePayment]);
  return (
    <>
      {cardList &&
        (isTailwindComponent ? (
          <TailwindPropertyPayment
            cardData={cardData}
            userId={userId}
            //addPromoCode={addPromoCode}
            promoCodeValue={promoCodeValue}
            defaultPromoCode={defaultPromoCode}
            uid={uid}
            default_card_id={default_card_id}
            propertiesIds={propertiesIds}
            selectedData={selectedData}
            selectedCategory={selectedCategory}
            userEmail={userEmail}
            stripeErr={stripeErr}
            validateErr={validateStripeErr}
            showInlineCardForm={showInlineCardForm}
            callListingAPI={callListingAPI}
            onInlineCardPay={onInlineCardPay}
            inlinePayLoading={inlinePayLoading}
            inlinePayLabel={inlinePayLabel}
            isAdmin={isAdmin}
            isServiceProvider={isServiceProvider}
            isAdminCreateUser={isAdminCreateUser}
            from={from}
            isUserCreateProperty={isUserCreateProperty}
            isUpgradeCategory={isUpgradeCategory}
            isEnhancedToCompleteProtection={isEnhancedToCompleteProtection}
            finalAmount={finalAmount}
            onFinalAmountChange={onFinalAmountChange}
            is_renew={is_renew}
          />
        ) : inlineCheckout ? (
          <InlinePaymentCheckout
            cardData={cardData}
            userId={userId}
            //  addPromoCode={addPromoCode}
            promoCodeValue={promoCodeValue}
            uid={uid}
            default_card_id={default_card_id}
            propertiesIds={propertiesIds}
            selectedData={selectedData}
            selectedCategory={selectedCategory}
            userEmail={userEmail}
            isTailwindComponent={isTailwindComponent}
            stripeErr={stripeErr}
            validateErr={validateStripeErr}
            showInlineCardForm={showInlineCardForm}
            from_admin={isAdmin}
            from={from}
            isUserCreateProperty={isUserCreateProperty}
            isUpgradeCategory={isUpgradeCategory}
            isEnhancedToCompleteProtection={isEnhancedToCompleteProtection}
            finalAmount={finalAmount}
            onFinalAmountChange={onFinalAmountChange}
            is_renew={is_renew}
          />
        ) : from === "add-subscriptions" || from === "add-property" ? (
          <CardList
            displayLabel={false}
            cardData={cardData}
            userId={userId}
            from={from}
            addPromoCode={addPromoCode}
            promoCodeValue={promoCodeValue}
            callListingAPI={callListingAPI}
            paySecure={paySecure}
            // for add properties
            uid={uid}
            default_card_id={default_card_id}
            setTotalAmountModal={setTotalAmountModal}
            isUserCreateProperty={isUserCreateProperty}
            isOpenFromBottom={isOpenFromBottom}
            propertiesIds={propertiesIds}
            selectedData={selectedData}
            selectedCategory={selectedCategory}
            userEmail={userEmail}
            isTailwindComponent={isTailwindComponent}
          />
        ) : (
          <CardList
            displayLabel={false}
            cardData={cardData}
            // for promocode
            addPromoCode={addPromoCode}
            promoCodeValue={promoCodeValue}
            paySecure={paySecure}
            isUserCreateProperty={isUserCreateProperty}
            isOpenFromBottom={isOpenFromBottom}
            propertiesIds={propertiesIds}
            selectedData={selectedData}
            default_card_id={default_card_id}
            callListingAPI={invToken ? callListingAPI : undefined}
            selectedCategory={selectedCategory}
            userEmail={userEmail}
            isTailwindComponent={isTailwindComponent}
          />
        ))}
      <Loader open={threedSecurePaymentLoader || paymentLoader} />

      {getObjLength(threedSecurePayment) &&
      !(skipSuccessModal && threedSecurePayment?.success) ? (
        threedSecurePayment?.success ? (
          <AlertDialog
            isTailwindComponent={isTailwindComponent}
            type="Success"
            openPopup={true}
            onClose={successClose}
            onCloseFun={handleSuccessModalClose}
            mesage={successMsg ? successMsg : threedSecurePayment?.message}
            footer={false}
          />
        ) : (
          <AlertDialog
            isTailwindComponent={isTailwindComponent}
            type="Error"
            openPopup={true}
            onClose={true}
            onCloseFun={onFailedModal}
            mesage={
              validationMsg?.length > 0
                ? validationMsg
                : threedSecurePayment?.message ||
                  threedSecurePayment?.data?.message ||
                  "Payment failed."
            }
            footer={false}
          />
        )
      ) : null}
    </>
  );
};

export default SecurePaymentPanel;
